import { ConditionalStep } from './types';

function findStep(allSteps: ConditionalStep[], stepName: string) {
  const result = allSteps.find((step) => step.step === stepName);
  if (!result) {
    throw new Error(`Step ${stepName} not found in findStep function.`);
  }
  return result;
}

// Responsible for getting the step's previousStep, and that previousStep's previousStep, and so on.
function getParentStep(
  allSteps: ConditionalStep[],
  currentStep: ConditionalStep,
  previousStepName: string | null = null
): ConditionalStep {
  // NOTE: first check if we find a step that has his previousStep to the previousStepName.
  const nextStep = allSteps.find(
    (elem) =>
      elem.stepOrder &&
      elem.stepOrder.length > 0 &&
      elem.stepOrder[0].previousStep === previousStepName
  );
  if (nextStep) return nextStep;
  if (!currentStep.stepOrder || currentStep.stepOrder.length === 0)
    return currentStep;
  if (currentStep.stepOrder[0].previousStep === previousStepName)
    return currentStep;
  return getParentStep(
    allSteps,
    findStep(allSteps, currentStep.stepOrder[0].previousStep),
    previousStepName
  );
}

// NOTE: order the steps according to their stepOrder parameter.
export default function getOrderedSteps(steps: ConditionalStep[]) {
  const result: ConditionalStep[] = [];
  const visitedSteps = new Set<string>();

  // NOTE: start by looking for a step that has null as previousStep because it's the starting point.
  // steps that have to stepOrder should come AFTER this step.
  let i = 0;

  const stepWithNullPreviousStep = steps.find(
    (step) =>
      step.stepOrder &&
      step.stepOrder.length > 0 &&
      step.stepOrder[0].previousStep === null
  );
  if (stepWithNullPreviousStep) {
    result.push(stepWithNullPreviousStep);
    visitedSteps.add(stepWithNullPreviousStep.step);
    if (stepWithNullPreviousStep.step === steps[i].step) i += 1;
  }
  while (result.length < steps.length) {
    const previousStepName =
      result.length > 0 ? result[result.length - 1].step : null;
    const nextStep = getParentStep(steps, steps[i], previousStepName);
    if (visitedSteps.has(nextStep.step)) {
      throw new Error(
        'Infinite loop in stepOrder (should have been caught earlier)'
      );
    }
    visitedSteps.add(nextStep.step);
    result.push(nextStep);
    if (nextStep.step === steps[i].step) i += 1;
  }

  return result;
}
